import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {filter, take, tap} from 'rxjs/operators';
import { UserEntity } from '../entities/user.entity';
import { State } from '../State';
import { ResolverLoadManageUserList } from '../State/actions/resolver.actions';

@Injectable({
    providedIn: 'root'
})
export class ManageUserListResolver implements Resolve<UserEntity[]> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(state => state.users.manageUserList);

        value$
            .pipe(
                filter(value => !value),
                take(1),
                tap(() => {
                    if (localStorage.getItem('token') != null) {
                    this.store.dispatch(new ResolverLoadManageUserList());
                }
                })
            )
            .subscribe();

        return value$.pipe(
            filter(value => !!value),
            take(1)
        );
    }
}
